import { observable } from "mobx";
import { api, api_adm } from "../../api";
import { ISpedTabelas } from "../../model";
import { toast } from "react-toastify";

export class _SpedTabelaStore {
  obs = observable({
    dadosTabela: [] as ISpedTabelas[],
  })

  async handleLoadTabelas(tabela: string, pacote: string, vigencia: boolean) {

    try {

      let resp = await api.post(`/api/tabela-sped`, { tabela: tabela, pacote: pacote, vigencia: vigencia });

      this.obs.dadosTabela = [];
      this.obs.dadosTabela = resp.data

    } catch (ex) {

      toast.error("Erro ao carregar Tabela Sped, tente novamente mais tarde.", {});

    }

  }

  async handleImport(data) {

    let resp = await api_adm.post("/api/admin/tabelas/import", data)

    if (resp.data.ok) {

      toast.success('Arquivo importado com sucesso!', {});

      return true

    }

    toast.error(resp.data.error, {});

    return false

  }

  async handleAplicaCredito(id, checked) {

    let data = {
      id: id,
      credito: checked
    }

    let resp = await api_adm.post('/api/admin/tabelas/credito', data);

    if (resp.data.ok) {
      toast.success('Crédito Atualizado!', {});
      return true

    } else {

      toast.error(`Não foi possível atualizar Crédito: ${resp.data.msg}`, {});

    }

    return false

  }

}

export const SpedTabelaStore = new _SpedTabelaStore();
